import React from "react";
import "./index.less";
import ZAlert from "@atoms/ZAlert";
import ZButton from "@atoms/ZButton";
import ZIcon from "@atoms/ZIcon";
import ZTypography from "@atoms/ZTypography";
import { EColors } from "@atoms/ZColors/interface";
import { EIcons } from "@atoms/ZIcon/interface";
import { EIconSizes } from "@atoms/ZButton/interface";

import { ZomentumRoutes } from "@/Contracts";

import {
	IPricingPlanErrorProps,
	IPricingPlanErrorTooltipProps,
	IPricingPlanUpgradeAlertProps
} from "./interface";
import ZTooltip from "@atoms/ZTooltip";
import Link from "antd/lib/typography/Link";

const { ZText, ZTitle } = ZTypography;

const ZPricingPLanError: React.FC<IPricingPlanErrorProps> = props => {
	return (
		<ZAlert
			className="pricing-plan-error-alert"
			message={
				<div className="header">
					<ZIcon
						name={EIcons.ADMINPROFILE}
						size={EIconSizes.large}
						color={EColors.ORANGE}
						colorVariant={5}
						className="icon"
					/>
					<ZTitle>{props.title}</ZTitle>
				</div>
			}
			description={
				<div className="content">
					<ZText color={EColors.GRAY} colorVariant={8}>
						{props.description}
					</ZText>
					<div className="mt-7 mb-4">
						<ZButton
							type="primary"
							title="Upgrade Now"
							onClick={() => {
								window.location.assign(ZomentumRoutes.Billing);
							}}
						>
							Upgrade Now
						</ZButton>
					</div>
					<div>
						{/* Todo: Update the contact Sales Link */}
						<Link
							href={`https://calendly.com/product-feedback-5/success-team-upsell?utm_source={{${window.location.pathname}}}`}
						>
							Contact Sales
						</Link>
					</div>
				</div>
			}
			type="warning"
		/>
	);
};

export const ZPricingPlanUpgradeAlert = ({
	title,
	description,
	footer,
	...props
}: IPricingPlanUpgradeAlertProps) => {
	return (
		<ZAlert
			message={
				<div
					className={`header ${
						props.textAlignmentLeft ? "text-left" : ""
					}`}
				>
					<ZTitle level={2}>{title}</ZTitle>
				</div>
			}
			showIcon
			icon={
				<ZIcon
					name={EIcons.ADMINPROFILE}
					size={EIconSizes.large}
					color={EColors.ORANGE}
					colorVariant={5}
					className="icon"
				/>
			}
			description={
				<div
					className={`content ${
						props.textAlignmentLeft ? "text-left" : ""
					}`}
				>
					<ZText color={EColors.GRAY} colorVariant={8} level={1}>
						{description}
					</ZText>
					<div className="mt-4">
						{!footer ? (
							<div className="flex items-center">
								<div className="mr-4">
									{/* Todo: Update the contact Sales Link */}
									<Link
										href={`https://calendly.com/product-feedback-5/success-team-upsell?utm_source={{${window.location.pathname}}}`}
									>
										Contact Sales
									</Link>
								</div>
								<div>
									<ZButton
										type="primary"
										title="Upgrade Now"
										onClick={() => {
											window.location.assign(
												ZomentumRoutes.Billing
											);
										}}
									>
										Upgrade Now
									</ZButton>
								</div>
							</div>
						) : (
							footer
						)}
					</div>
				</div>
			}
			type="warning"
		/>
	);
};

export const ZPricingPlanErrorTooltip: React.FC<
	IPricingPlanErrorTooltipProps
> = ({ title, description, children, placement, shouldShowAlert, footer }) => {
	return (
		<ZTooltip
			title={
				<ZPricingPlanUpgradeAlert
					title={title}
					description={description}
					footer={footer}
				/>
			}
			className="pricing-plan-error-tooltip p-0"
			placement={placement}
			showtooltip={shouldShowAlert}
		>
			{children}
		</ZTooltip>
	);
};

export default ZPricingPLanError;
